import { CONFIG } from '../../../config'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/roteirizacao`

const RoteirizacaoPreviaRoutes = {
  urlSave: `${BASE_URL}/save`,

  urlGetRoteirizacoesPorPeriodo: (pInicial, pFinal, tp_id) => {
    return `${BASE_URL}/por-periodo?pInicial=${pInicial}&pFinal=${pFinal}&tpId=${tp_id}`
  },
  urlDeleteRoteirizacaoPrevia: roteirizacaoId => {
    return `${BASE_URL}/apagar/${roteirizacaoId}`
  },
  urlGetEntregas: roteirizacao_id => {
    return `${BASE_URL}/entregas/${roteirizacao_id}`
  },
  urlAssociarEntregas: roteirizacao_id => {
    return `${BASE_URL}/associacao/${roteirizacao_id}`
  },
  urlImportarGradeContingencia: (roteirizacao_id, dia_cross) => {
    return `${BASE_URL}/importar-grade-contingencia?roteirizacao_id=${roteirizacao_id}&dia_cross=${dia_cross}`
  },
}

export default RoteirizacaoPreviaRoutes
